import React from 'react'
import icon from './svgs/arrowRightBracket.svg'
import { BaseIcon } from './_base'

export const ArrowRightBracketIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
